import { useLockBodyScroll } from 'hooks/use-lock-body-scroll'

export const LockBodyScroll = () => useLockBodyScroll()
